import { useEffect, useRef, useState } from "react";

// Counts down while not paused; returns handlers to attach to the popup container
export const useAutoClose = (seconds, open, onClose) => {
  const [left, setLeft] = useState(1);
  const [hover, setHover] = useState(false);
  const [focus, setFocus] = useState(false);
  const remaining = useRef(0);
  const enabled = open && seconds > 0;
  useEffect(() => { if (open) { remaining.current = seconds * 1000; setLeft(1); setHover(false); setFocus(false); } }, [open, seconds]);
  const paused = hover || focus;
  useEffect(() => {
    if (!enabled || paused) return undefined;
    let last = Date.now();
    const id = setInterval(() => {
      const now = Date.now();
      remaining.current -= now - last;
      last = now;
      if (remaining.current <= 0) { clearInterval(id); onClose(); return; }
      setLeft(remaining.current / (seconds * 1000));
    }, 100);
    return () => clearInterval(id);
  }, [enabled, paused, seconds, onClose]);
  const handlers = enabled ? {
    onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false),
    onFocusCapture: (e) => { if (e.target.matches("input, textarea, select")) setFocus(true); },
    onBlurCapture: (e) => { if (e.target.matches("input, textarea, select")) setFocus(false); },
  } : {};
  return { enabled, left, paused, handlers };
};

export const AutoCloseBar = ({ left, paused }) => (
  <div className="absolute top-0 inset-x-0 h-1 bg-slate-200/60 z-20 pointer-events-none" data-testid="popup-countdown" data-paused={paused ? "true" : "false"}>
    <div className={`h-full origin-left transition-[transform] duration-100 ease-linear ${paused ? "bg-slate-400" : "bg-[#F5551E]"}`}
      style={{ transform: `scaleX(${Math.max(0, left)})` }} />
  </div>
);
